module.exports = __webpack_public_path__ + "static/media/claims.0d21c009.svg";